module.exports = __webpack_public_path__ + "static/media/p7.2fcd1fe5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/personalization/images/urbanhipster/p7.jpg
// module id = 2941
// module chunks = 0